import { isAfter, isBefore, isEqual, startOfDay } from 'date-fns'
import Vue from 'vue'

//Utile plus tard sur badge menu burger
const countThemeAvecNouveaute = function (faqThemes) {
  let nbThemeANouveaute = 0
  for (const faqTheme of faqThemes) {
    for (const faqQuestionReponse of faqTheme.questionsReponses) {
      if (this.isQuestionReponseNouveauteActive(faqQuestionReponse) && Vue.$cookies.get('FAQ_QUESTION_DEJA_VU_' + faqQuestionReponse.id) == null) {
        nbThemeANouveaute++
      }
    }
  }
  return nbThemeANouveaute
}

const hasAtLeastOneNouveaute = function (faqTheme) {
  return faqTheme.questionsReponses && faqTheme.questionsReponses.some(question => isQuestionReponseNouveauteActive(question))
}

const isQuestionReponseNouveauteActive = function (faqQuestionReponse) {
  if (faqQuestionReponse.nouveaute) {
    const dateDuJour = new Date(Date.now())
    const dateDebutNouveaute = startOfDay(new Date(faqQuestionReponse.dateDebutNouveaute))
    const dateFinNouveaute = startOfDay(new Date(faqQuestionReponse.dateFinNouveaute))
    return Vue.$cookies.get('FAQ_QUESTION_DEJA_VU_' + faqQuestionReponse.id) == null &&
      ((isEqual(dateDuJour, dateDebutNouveaute) || isAfter(dateDuJour, dateDebutNouveaute)) &&
        (isEqual(dateDuJour, dateFinNouveaute) || isBefore(dateDuJour, dateFinNouveaute)))
  }
  return false
}

const isQuestionReponseNouveauteVueMobileActive = function (faqQuestionReponse) {
  if (faqQuestionReponse.nouveaute) {
    const dateDuJour = new Date(Date.now())
    const dateDebutNouveaute = startOfDay(new Date(faqQuestionReponse.dateDebutNouveaute))
    const dateFinNouveaute = startOfDay(new Date(faqQuestionReponse.dateFinNouveaute))
    return ((isEqual(dateDuJour, dateDebutNouveaute) || isAfter(dateDuJour, dateDebutNouveaute)) &&
      (isEqual(dateDuJour, dateFinNouveaute) || isBefore(dateDuJour, dateFinNouveaute)))
  }
  return false
}

export default {
  countThemeAvecNouveaute,
  hasAtLeastOneNouveaute,
  isQuestionReponseNouveauteActive,
  isQuestionReponseNouveauteVueMobileActive
}
